var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1930(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-31.75485, 1)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(15.046142, 12.027325) scale(-1, 1) translate(-15.046142, -12.027325)",
    d: "M15.3013143,24.0546492 C13.1958887,24.0546492 11.1464985,23.8327548 9.5925427,23.3275184 C5.51152951,21.9927383 2.07799791,17.7460213 0.942940488,15.1583914 C-0.194167004,12.5639341 0.0104986779,9.12627805 0.0204073669,8.98290014 C0.0299743771,8.85317728 0.259582621,5.96513658 1.23336758,4.08859288 C2.3164898,2.00244433 5.42132627,-0.0792663281 8.70246908,0.00232252845 C12.0078711,0.104735319 15.1089491,3.03237563 16.3014086,5.62239511 C18.2281361,2.80058135 21.9428694,-0.527151599 26.4526897,1.17563173 C29.5004658,2.32572737 29.8394113,6.23482359 30.0023921,8.11239142 C30.017426,8.28649317 30.0310932,8.44352611 30.045102,8.5800765 C30.2138914,10.1981986 29.8927132,14.4346744 29.6658384,16.3532073 C29.405479,18.5482548 25.2687722,22.2180465 23.1923893,22.9451773 C21.2390108,23.6279292 18.2168607,24.0546492 15.3013143,24.0546492 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.845150, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-13.845150, -19.000000) translate(5.845150, 11.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    x1: 2.84514987,
    y1: 3.5,
    x2: 22.8451499,
    y2: 20.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1930);
export default __webpack_public_path__ + "static/media/19-30.c68e01ff8af046c216678c97f645099a.svg";
export { ForwardRef as ReactComponent };